import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Chat from "./ChatV1";

function ChatLogin() {
  const navigate = useNavigate();
  const [session, setSession] = useState(null);
  const [userId, setUserId] = useState("");
  const [userRole, setUserRole] = useState("all");
  const [engine, setEngine] = useState("agent");

  const startSession = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/session/start`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ user_id: userId, user_role: userRole, engine: engine }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      setSession(data.id_session);
    } catch (error) {
      console.error("Failed to start session:", error);
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>Renox Assistant</h1>
        {!session ? (
          <div>
            <input
              type="text"
              placeholder="User ID"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
            />
            <select
              value={userRole}
              onChange={(e) => setUserRole(e.target.value)}
            >
			  <option value="all">Admin</option>
              <option value="cs">Customer Service</option>
              <option value="eu">End User</option>
              <option value="in">Installer</option>
            </select>
            <select
              value={engine}
              onChange={(e) => setEngine(e.target.value)}
            >
			  <option value="agent">Agent</option>
              <option value="assistant">Assistant (Legacy)</option>
            </select>
            <button onClick={startSession}>Start Chat Session</button>
          </div>
        ) : (
          <Chat
            session={session}
            closeSession={() => setSession(null)}
          />
        )}
        <div>
          <button onClick={() => navigate("/")}>Back</button>
        </div>
      </header>
    </div>
  );
}

export default ChatLogin;